import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useVat, vatHint, eur } from "@/lib/workflow";
import { useAuth } from "@/context/AuthContext";

export function ConfirmPriceDialog({ row, onCancel, onConfirm }) {
  const [price, setPrice] = useState("");
  const [comment, setComment] = useState("");
  const chef = !!useAuth().user?.is_chef;
  const [mail, setMail] = useState(chef);
  const vat = useVat();
  const open = !!row;
  useEffect(() => {
    if (row) { setPrice(String(row.final_price ?? row.booking?.price ?? row.amount ?? "")); setComment(row.price_comment || ""); setMail(chef); }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const valid = price !== "" && !Number.isNaN(Number(price.replace(",", "."))) && Number(price.replace(",", ".")) >= 0;
  return (
    <Dialog open={!!row} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent data-testid="confirm-price-dialog">
        <DialogHeader>
          <DialogTitle>Zusage an {row?.name || row?.customer?.name}</DialogTitle>
          <DialogDescription>Trag den vereinbarten Endpreis ein. Er wird gespeichert und später in die Auftragsbestätigung übernommen.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {row?.booking && (
            <div className="text-sm rounded-md bg-slate-50 border border-slate-200 px-3 py-2">
              {row.booking.format} · Preisliste {row.booking.price} € netto
              {row.booking.price_note && <div className="text-amber-700 text-xs mt-1">Anmerkung des Kunden: {row.booking.price_note}</div>}
            </div>
          )}
          {(row?.last_invoice || row?.customer?.last_invoice) && (() => {
            const li = row.last_invoice || row.customer.last_invoice;
            return (
              <div className="text-sm rounded-md bg-emerald-50 border border-emerald-200 text-emerald-900 px-3 py-2" data-testid="confirm-prev-year">
                Vorjahr: {li.subject} · {li.no} · <b>{li.net.toLocaleString("de-DE", { minimumFractionDigits: 2 })} € netto</b>
              </div>
            );
          })()}
          <div><Label>Vereinbarter Endpreis (€, {vatHint(vat)})</Label><Input value={price} onChange={(e) => setPrice(e.target.value)} inputMode="decimal" className="mt-1" data-testid="confirm-price-input" />{valid && <div className="text-xs text-slate-500 mt-1" data-testid="confirm-price-gross">brutto {eur(Number(price.replace(",", ".")) * (1 + vat / 100))}</div>}</div>
          <div><Label>Interne Notiz zum Preis (optional)</Label><Textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={2} placeholder="z. B. 20 % Nachlass wie im Vorjahr" data-testid="confirm-price-comment" /></div>
          {chef && <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={mail} onChange={(e) => setMail(e.target.checked)} className="accent-slate-900" data-testid="confirm-send-mail" /> Zusage-Mail mit Upload-Link an den Kunden senden</label>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="confirm-price-cancel">Abbrechen</Button>
          <Button disabled={!valid} onClick={() => onConfirm({ final_price: Number(price.replace(",", ".")), price_comment: comment, send_mail: chef && mail })} className="bg-emerald-600 hover:bg-emerald-700" data-testid="confirm-price-submit">Zusagen</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
